export default __webpack_public_path__ + "static/FuturaNDMedium-be9d7818d3c5691b2a0409eddc59a5e3.woff";